module.exports = __webpack_public_path__ + "assets/img/back-492d6e26.png";